import { TextAlign } from 'chart.js';
import styled from 'styled-components';

export const headerStyle = {
  minWidth: '100px',
  border: '0px 0px 1px 0px',
  padding: '16px',
  textAlign: 'left' as TextAlign,
  fontSize: '14px',
  fontFamily: 'DM Sans',
  fontWeight: 700,
  color: '#0B1F1C',
  borderBottom: '1px solid #0B1F1C29',
};

export const rowStyle = {
  padding: '24px 16px 24px 16px',
  border: '0px, 0px, 1px, 0px',
  borderBottom: '1px solid #0B1F1C29',
};

export const TableWrapper = styled.div`
  overflow-x: auto;
  overflow-y: auto;
  padding: 0;
  margin-bottom: 24px;
  max-height: 375px;
`;

export const PlaceholderImage = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #d9d9d9;
`;
